


window.addEventListener("load", (event) => {
  document.querySelector('.product-form-buttons button')?.addEventListener('click', function() {
  setTimeout(function() {
    const cartButton = document.querySelector('.header__column.header__column--right .header-actions__action.action__cart');
    cartButton?.click();
  }, 2000); // 2 second delay instead of 1
});
});



